module.exports = __webpack_public_path__ + "static/media/Security.511f52d5.png";